import Page, { getProps } from '@/modules/media/album'

export const getServerSideProps = getProps

export default Page
